var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.78695 666.66664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #c6c6c6;\n        isolation: isolate;\n      }\n\n      .cls-2 {\n        fill: #7c7c7c;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bell__body",
    className: "cls-1",
    d: "M644.66328,482.99664,611.33,427.66331c-7-12.33333-13.33332-35.66666-13.33332-49.33332V293.99664c0-108.66665-88.33332-197.33331-197.3333-197.33331-108.99868,0-197.332,88.66666-197.332,197.33331V378.33c0,13.66666-6.33334,37-13.33332,49l-33.66667,55.66667c-13.33334,22.33333-16.33333,47-8,69.6667,8,22.33333,27,39.66662,51.66666,48,64.66667,22,132.66668,32.66671,200.66534,32.66671A632.31339,632.31339,0,0,0,601.33,600.99663a80.3817,80.3817,0,0,0,43.33331-118Z",
    transform: "translate(-143.6848 -66.66666)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "dark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "handle",
    className: "cls-2",
    d: "M475.02665,110.66666a203.29391,203.29391,0,0,0-74.33334-14,196.1486,196.1486,0,0,0-74.00065,14,84.50829,84.50829,0,0,1,148.334,0Z",
    transform: "translate(-143.6848 -66.66666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "striker",
    className: "cls-2",
    d: "M494.32333,667A100.48131,100.48131,0,0,1,399.99,733.33331a98.84192,98.84192,0,0,1-70.667-29.66665c-10.66665-10-18.66668-23.33336-23.33332-37,4.33333.66668,8.66664,1,13.33332,1.66664,7.66668,1,15.667,2.00005,23.667,2.66667,19,1.6667,38.33335,2.66666,57.66668,2.66666,19,0,38-1,56.66666-2.66666,7-.66662,14-1,20.66666-2C483.3233,668.33328,488.65666,667.66666,494.32333,667Z",
    transform: "translate(-143.6848 -66.66666)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification-bell.9ebcdc02.svg";
export { ForwardRef as ReactComponent };